// import Zoom from 'Zoom';
import log from 'salvo-lite/log'

class ProductImages {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._options = JSON.parse(elem.getAttribute('data-product-images'))
        this._imageGroups = elem.querySelectorAll('[data-img-group]')
        this._currentGroup = null
        this._index = null

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        if (this._options.imageGroupSwitcher) {
            this._imageGroupSwitchers = document.querySelector(this._options.imageGroupSwitcher).querySelectorAll('[data-img-switcher]')

            this.initCurrentGroup()
            this.initGroupSwitchListener()
        }

        this._imageGroups.forEach(group => {
            const groupValue = group.getAttribute('data-img-group')

            group.querySelectorAll('.product-img--zoom').forEach(el => {
                const lightboxData = JSON.parse(el.getAttribute('data-img-lightbox'))

                el.addEventListener('click', () => {
                    this.initLightbox(groupValue, lightboxData)
                })
            })
        })
    }

    initCurrentGroup () {
        this._imageGroupSwitchers.forEach(el => {
            if (el.classList.contains('checked')) {
                this._imageGroups.forEach(group => {
                    const groupValue = group.getAttribute('data-img-group')
                    const switcherValue = el.getAttribute('data-img-switcher')

                    if (groupValue === switcherValue) {
                        this._currentGroup = groupValue
                        return el
                    }
                })
            }
        })

        this._imageGroups.forEach(group => {
            const groupValue = group.getAttribute('data-img-group')

            if (groupValue !== this._currentGroup) {
                group.classList.remove('active')
            }
        })
    }

    initGroupSwitchListener () {
        this._imageGroupSwitchers.forEach(el => {
            el.addEventListener('click', () => {
                const switcherValue = el.getAttribute('data-img-switcher')

                this._imageGroups.forEach(group => {
                    const groupValue = group.getAttribute('data-img-group')

                    if (groupValue === switcherValue) {
                        this._currentGroup = groupValue
                        group.classList.add('active')
                    } else {
                        group.classList.remove('active')
                    }
                })
            })
        })
    }

    initLightbox (group, data) {
        this._index = data.index

        const lightbox = document.createElement('div')
        lightbox.classList.add('lightbox')

        const container = document.createElement('div')
        container.classList.add('lightbox__inner-container')

        lightbox.appendChild(container)

        const closeBtn = document.createElement('span')
        closeBtn.classList.add('lightbox-close')
        closeBtn.innerHTML = '&times;'
        closeBtn.setAttribute('aria-label', 'Close')
        closeBtn.addEventListener('click', function () {
            document.body.removeChild(lightbox)
        })

        lightbox.appendChild(closeBtn)

        const img = document.createElement('img')
        img.src = data.image
        img.classList.add('lightbox__img')

        container.appendChild(img)
        container.classList.add('lightbox--has-image')
        lightbox.classList.add('lightbox--has-image')
        closeBtn.classList.add('lightbox--has-image')

        const nextBtn = document.createElement('div')
        nextBtn.classList.add('lightbox--next')
        nextBtn.addEventListener('click', () => {
            this.cycleImages('next', group)
        })

        const prevBtn = document.createElement('div')
        prevBtn.classList.add('lightbox--prev')
        prevBtn.addEventListener('click', () => {
            this.cycleImages('prev', group)
        })

        const btns = [nextBtn, prevBtn]
        btns.forEach(btn => {
            btn.classList.add('lightbox__custom-arrow')
            btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11"><g><g><path d="M5.875 4.962L.73.113a.447.447 0 0 0-.606.01.388.388 0 0 0 0 .562l4.84 4.563L.125 9.81a.388.388 0 0 0 0 .572.447.447 0 0 0 .606 0l5.144-4.849a.388.388 0 0 0 0-.571z"/></g></g></svg>'
            btn.classList.add('flex', 'f-vertical-center', 'f-center')

            lightbox.appendChild(btn)
        })

        document.body.appendChild(lightbox)
    }

    cycleImages (direction, group) {
        const groupNodes = document.querySelector(`[data-img-group=${group}]`).querySelectorAll('.product-img__container')

        let nextIndex

        if (direction === 'next') {
            if (groupNodes.length === this._index + 1) {
                nextIndex = 0
            } else {
                nextIndex = this._index + 1
            }
        } else {
            if (this._index === 0) {
                nextIndex = groupNodes.length - 1
            } else {
                nextIndex = this._index - 1
            }
        }

        const _nextImage = groupNodes[nextIndex]
        const lightboxSelector = _nextImage.querySelector('[data-img-lightbox]')
        const lightboxJSON = JSON.parse(lightboxSelector.getAttribute('data-img-lightbox'))
        const image = lightboxJSON.image

        document.querySelector('.lightbox__img').src = image
        this._index = nextIndex
    }
}

export default ProductImages



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ProductImages.js